import { mdiDelete, mdiMagnify } from '@mdi/js';
import { IconButton, MenuItem, Paper } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { withTheme } from '@mui/styles';
import React from 'react';
import Autosuggest from 'react-autosuggest';
import { Icon, TextInput } from '.';
import * as StyleGlobal from '../infra/styleGlobal';
import Progress from './Progress';
import View from './View';
let contador = 1;
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    // console.log(888);
    this.state = {
      value: this.props.value ? this.props.value : '',
      suggestions: [],
    };
    this.contador = contador++;
  }
  getSuggestions(value) {
    const { list = [], keyLabel = 'nome' } = this.props;
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
      return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');
    if (this.props.returnall) return list;
    else return list.filter((item) => regex.test(item[keyLabel]));
  }

  onChange(event, { newValue, method }) {
    this.setState({
      value: newValue,
    });
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }
  clear() {
    this.setState({ value: '' });
  }

  render() {
    const { value, suggestions } = this.state;
    const { theme, list = [], keyLabel = 'nome', label = '', placeholder = 'Selecione', onChange, onChangeText, variant, load, otherInputprops } = this.props;
    const inputProps = {
      load,
      placeholder,
      value,
      label,
      otherInputprops,
      clear: () => {
        this.clear();
        onChange({});
      },
      onChange: (event, { newValue, method }) => {
        this.setState(
          {
            value: newValue,
          },
          () => {
            if (onChangeText) onChangeText(newValue);
          }
        );
      },
    };

    return (
      <Autosuggest
        id={this.contador + 'key'}
        suggestions={suggestions}
        renderInputComponent={renderInputComponent}
        onSuggestionsFetchRequested={({ value }) => {
          setTimeout(() => {
            this.setState({
              suggestions: this.getSuggestions(value),
            });
          }, 500);
        }}
        onSuggestionsClearRequested={() => {
          this.setState({
            suggestions: [],
          });
        }}
        getSuggestionValue={(suggestion) => suggestion[keyLabel]}
        renderSuggestion={(suggestion, { query, isHighlighted }) => (
          <MenuItem selected={isHighlighted} component="div">
            {suggestion[keyLabel]}
          </MenuItem>
        )}
        onSuggestionSelected={(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
          onChange(suggestion);
        }}
        ref={(v) => (this.autosuggest = v)}
        theme={{
          container: styles(theme).container,
          suggestionsContainerOpen: styles(theme).suggestionsContainerOpen,
          suggestionsList: styles(theme).suggestionsList,
          suggestion: styles(theme).suggestion,
        }}
        inputProps={inputProps}
        renderSuggestionsContainer={(options) => (
          <Paper {...options.containerProps} square>
            {options.children}
          </Paper>
        )}
      />
    );
  }
}

function renderInputComponent(inputProps) {
  const { inputRef = () => {}, ref, style, load, otherInputprops, clear, ...other } = inputProps;
  return (
    <TextInput
      inputForAutocomplete={true}
      style={style}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
              {load ? <Progress load={load} /> : <Icon size={1} color={StyleGlobal.StyleIconBotao} path={mdiMagnify} />}
              {load ? (
                <Progress load={load} />
              ) : (
                <IconButton
                  onClick={() => {
                    clear();
                  }}
                >
                  <Icon size={1} color={StyleGlobal.StyleIconBotao} path={mdiDelete} />
                  {/* <Delete style={{ color: StyleGlobal.StyleIconBotao }} /> */}
                </IconButton>
              )}
            </View>
          </InputAdornment>
        ),
        inputRef: (node) => {
          ref(node);
          inputRef(node);
        },
      }}
      {...otherInputprops}
      {...other}
    />
  );
}

const styles = (theme) => {
  return {
    container: {
      position: 'relative',
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 999,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    divider: {
      height: theme.spacing(2),
    },
  };
};
export default withTheme(AutoComplete);
